import { useEffect, useRef } from "react";

const GoogleTranslate = () => {
  const isMounted = useRef(true);

  useEffect(() => {
    const googleTranslateElementInit = () => {
      if (isMounted.current) {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "en",
            includedLanguages: "en,hi,kn,ml,pa,ta,te,bn",
          },
          "google_translate_element"
        );
      }
    };

    window.googleTranslateElementInit = googleTranslateElementInit;

    const script = document.createElement("script");
    script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;
    document.head.appendChild(script);

    return () => {
      isMounted.current = false;
      
      // Delay cleanup to allow pending operations to complete
      setTimeout(() => {
        try {
          if (script && script.parentNode) {
            script.parentNode.removeChild(script);
          }
          
          const translateElement = document.getElementById('google_translate_element');
          if (translateElement) {
            translateElement.innerHTML = '';
          }

          delete window.googleTranslateElementInit;
          delete window.google;
        } catch (error) {
          console.warn('Cleanup of Google Translate failed:', error);
        }
      }, 100);
    };
  }, []);

  return (
    <div>
      <div id="google_translate_element" className="w-full"></div>
    </div>
  );
};

export default GoogleTranslate;
